module.exports = __webpack_public_path__ + "static/media/vignesh.0c4cd935.png";